import { LayoutContext } from "Components/LayoutContext";
import LsLoading from "Components/LsLoading";
import { Modal, ModalBody } from "Components/ReactstrapSlim";
import useUnmountedSignal from "Hooks/useUnmountedSignal";
import React from "react";
import { useContext, useEffect, useState } from "react";
import { ITeamMemberReservation, ReservationsClient } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import anySignal from "Utils/anySignal";
import { ReservationDetailsModalInternal } from "./ReservationDetailsModalInternal";

export interface ReservationDetailsModalByIdProps {
    isOpen: boolean,
    id: Guid,
    occurrenceDate?: string,
    container?: string | HTMLElement;
    toggle: () => void,
    onUpdateReservation: (reservationId?: Guid, occurrenceDate?: string) => void;
    onUpdateReservationList?: () => void
}

export const ReservationDetailsModalById: React.FC<ReservationDetailsModalByIdProps> = ({ id, occurrenceDate, container, isOpen, toggle, onUpdateReservation, onUpdateReservationList }) => {
    const layoutContext = useContext(LayoutContext);
    const reservationsClient = useApiClient(ReservationsClient);
    const [isLoading, setIsLoading] = useState(false);
    const [reservationDetails, setReservationDetails] = useState<ITeamMemberReservation | undefined>(undefined);
    const unmountedSignal = useUnmountedSignal();

    const loadReservation = (reservationId: Guid, occurrenceDate?: string, signal?: AbortSignal) => {
        setIsLoading(true);
        reservationsClient.get(reservationId, occurrenceDate, undefined, anySignal(unmountedSignal, signal))
            .then(data => setReservationDetails(data))
            .catch(ex => unmountedSignal.aborted || layoutContext.showError(ex))
            .finally(() => setIsLoading(false));
    }

    const onUpdateReservationInternal = async (reservationId?: Guid, occurrenceDate?: string) => {
        if (reservationId) {
            loadReservation(reservationId, occurrenceDate);
        }
        await onUpdateReservation(reservationId, occurrenceDate);
    }
  
    const onUpdateReservationListInternal = async (reservationId?: Guid, occurrenceDate?: string) => {
        if (reservationId) {
            loadReservation(reservationId, occurrenceDate);
        }
        await onUpdateReservationList?.();
    }

    useEffect(() => {
        const abortController = new AbortController();
        loadReservation(id, occurrenceDate, abortController.signal);
        return () => {
            abortController.abort();
        }
    }, [id])

    return reservationDetails && !isLoading 
        ? <ReservationDetailsModalInternal isOpen={isOpen} reservation={reservationDetails} container={container} toggle={toggle} onUpdateReservation={onUpdateReservationInternal} onUpdateReservationList={onUpdateReservationListInternal}/>
        : <Modal isOpen={isLoading} container={container}>
            <ModalBody style={{ minHeight: "400px" }}>
                <LsLoading isLoading={isLoading} />
            </ModalBody>
        </Modal>
}